import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";



export default function MarkerLess({ data, username }) {
    const [previewGlbModel, setPreviewGlbModel] = useState(data.glb_model[0])
    const [previewUsdzModel, setPreviewUsdzModel] = useState(data.usdz_model[0])
    const [selectSlide, setSelectSlide] = useState(0)
    const [progress, setProgress] = useState(1)
    const search = useLocation().search;
    const isWebEmbed = new URLSearchParams(search).get("isWebEmbed");


    const url = `${process.env.REACT_APP_SERVER}/uploads/${data.user.username}/3d_model`;


    const switchSrc = (index) => {
        if (selectSlide != index) {
            const progressBarModel = document.querySelector(".progress-bar-model");
            progressBarModel.style.display = "block";
            setSelectSlide(index)
            setPreviewGlbModel(data.glb_model[index])
            setPreviewUsdzModel(data.usdz_model[index])
        }
    };

    useEffect(() => {
        viewAR()
        const modelViewer = document.getElementById("viewer");
        const progressBarModel = document.querySelector(".progress-bar-model");
        modelViewer.addEventListener("progress", (event) => {
            const progressPercentage = event.detail.totalProgress * 100;
            setProgress(progressPercentage)
        });
        modelViewer.addEventListener("load", () => {
            progressBarModel.style.display = "none";
        });
    }, [])

    async function viewAR() {

        var body = {
            id: data._id
        };

        await fetch(`${process.env.REACT_APP_SERVER}/api/nft/view/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        })
    }


    return (
        <>
            <div className='relative'>
                {
                    isWebEmbed ?
                        isWebEmbed.match(false) ? (
                            <div className='absolute flex items-stretch w-full h-[50px] bg-opacity-40 bg-black text-white text-center z-10'>
                                <p className='m-auto'>{data.user.name}</p>
                            </div>
                        ) : (null)
                        : (
                            <div className='absolute flex items-stretch w-full h-[50px] bg-opacity-40 bg-black text-white text-center z-10'>
                                <p className='m-auto'>{data.user.name}</p>
                            </div>
                        )
                }
                <div className='model-viewer-container'>
                    <model-viewer
                        id="viewer"
                        src={`${url}/${previewGlbModel}`}
                        ios-src={`${url}/${previewUsdzModel}`}
                        alt={data.name}
                        camera-controls
                        touch-action="pan-y"
                        ar
                        ar-modes="webxr scene-viewer quick-look"
                        // ar-placement="floor, wall"
                        shadow-intensity="1"
                        fullscreen
                    >
                        <button style={{ fontFamily: 'IRANSans' }} slot="ar-button" id="ar-button">
                            مشاهده واقعیت افزوده
                        </button>

                        <button id="ar-failure">
                            AR is not tracking!
                        </button>

                        <div className="slider">
                            <div className="slides">
                                {data.glb_model.length != 1 && data.glb_model.map((item, index) => {
                                    return (
                                        <div key={index}>
                                            {/* style="background-image: url('../../assets/ShopifyModels/Chair.webp');" */}
                                            <button className={`slide ${selectSlide == index ? "selected" : null}`} onClick={() => switchSrc(index)} >
                                                <span className='m-auto font-bold text-xl'>{index + 1}</span>
                                            </button>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </model-viewer>
                    <div className="progress-bar-model">
                        <div className={`progress-model`} style={{width: `${progress}%`}}></div>
                    </div>
                </div>
            </div>
        </>
    )

}

